module.exports = __webpack_public_path__ + "dfa68db4ca744f49383b4def1b8241af.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=1400!./images/head/ALLEYESONUS_HEAD.jpg
// module id = 754
// module chunks = 0